<template>
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="close" dark>
        <v-icon>fa-times</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field label="Nazwa" v-model="nazwa" :rules="[nazwa_rules.required, nazwa_rules.min_length]"></v-text-field>
            </v-col>
            <!--<v-row no-gutters>
              <v-col cols="6">
                <label>Przypisany kolor</label>
                <ColorPicker :color="kolor" v-model="kolor"/>
              </v-col>
            </v-row>-->
            <v-col cols="12">
              <v-checkbox label="Grupuj wizyty na głównym kalendarzu" v-model="grupuj"></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" color="error">Zamknij</v-btn>
      <v-btn color="success" @click="save">Zapisz</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import {zabiegiService} from "@/services";
import swal from "sweetalert";
import ColorPicker from "@/components/shared/ColorPicker.vue";
export default {
  name: "KategoriaEdit",
  components: {},
  props: ['zabieg'],
  data() {
    return {
      valid: true,
      nazwa: '',
      grupuj: false,
      kolor: '0',
      title: 'Dodawanie kategorii',
      nazwa_rules: {
        required: value=> !!value || 'Nazwa jest wymagana',
        min_length: value=> !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
    }
  },
  mounted() {
    if(this.zabieg && this.zabieg.id > 0)
    {
      this.nazwa = this.zabieg.nazwa
      this.grupuj = this.zabieg.grupujNaGlownymKalendarzu
      this.kolor = this.zabieg.kolor
      this.title = 'Edycja kategorii'
    }
  },
  methods: {
    close()
    {
      this.$emit('close')
    },
    save()
    {
      if(this.$refs.form.validate())
      {
        if(this.zabieg && this.zabieg.id > 0)
        {
          zabiegiService.updateKategoria({ id: this.zabieg.id, nazwa: this.nazwa, kolor: this.kolor, grupujNaGlownymKalendarzu: this.grupuj}).then(() => {
            this.$emit('saved')
          }).catch((err) => {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false,err.response.data.error.message)
            } else {
              this.showError(false,"Błąd zapisu kategorii.");
            }
          })
        }
        else
        {
          zabiegiService.insertKategoria({nazwa: this.nazwa, kolor: this.kolor, grupujNaGlownymKalendarzu: this.grupuj}).then(() => {
            this.$emit('saved')
          }).catch((err)=> {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false,err.response.data.error.message)
            } else {
              this.showError(false,"Błąd zapisu kategorii.");
            }
          })
        }
      }
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
  }
}
</script>

<style scoped>

</style>